type LanguageCode = string;

const languageSupport = {
  hr: { vector: true, astronaut: true, amf: true },
  cs: { vector: true, astronaut: true, amf: true },
  da: { vector: true, astronaut: true, amf: true },
  nl: { vector: true, astronaut: true, amf: true },
  en: { vector: true, astronaut: true, amf: true },
  et: { vector: true, astronaut: true, amf: true },
  fi: { vector: true, astronaut: true, amf: true },
  fr: { vector: true, astronaut: true, amf: true },
  de: { vector: true, astronaut: true, amf: true },
  el: { vector: true, astronaut: true, amf: true },
  he: { vector: false, astronaut: true, amf: true },
  hu: { vector: false, astronaut: true, amf: true },
  is: { vector: true, astronaut: true, amf: true },
  it: { vector: true, astronaut: true, amf: true },
  ja: { vector: true, astronaut: true, amf: true },
  ko: { vector: true, astronaut: true, amf: true },
  lv: { vector: true, astronaut: true, amf: true },
  lt: { vector: true, astronaut: true, amf: true },
  no: { vector: true, astronaut: true, amf: true },
  pl: { vector: true, astronaut: true, amf: true },
  pt: { vector: true, astronaut: true, amf: true },
  ro: { vector: true, astronaut: true, amf: true },
  ru: { vector: true, astronaut: true, amf: true },
  sk: { vector: false, astronaut: true, amf: true },
  sl: { vector: true, astronaut: true, amf: true },
  es: { vector: true, astronaut: true, amf: true },
  sr: { vector: false, astronaut: true, amf: true },
  sv: { vector: true, astronaut: true, amf: true },
  tr: { vector: true, astronaut: true, amf: true },
  zh_cn: { vector: false, astronaut: true, amf: true },
  zh_tw: { vector: false, astronaut: true, amf: true },
};

export const getLanguageImpactMessage = (
  language: LanguageCode,
): string | null => {
  const support = languageSupport[language];

  if (!support) return null;

  const supportedProducts: string[] = [];
  if (support.astronaut) supportedProducts.push('Astronaut');
  if (support.vector) supportedProducts.push('Vector');
  if (support.amf) supportedProducts.push('Automatic milk filter');

  if (supportedProducts.length === 0) return null;

  let productList: string;
  if (supportedProducts.length === 1) {
    productList = supportedProducts[0];
  } else if (supportedProducts.length === 2) {
    productList = supportedProducts.join(' and ');
  } else {
    productList =
      supportedProducts.slice(0, -1).join(', ') +
      ' and ' +
      supportedProducts[supportedProducts.length - 1];
  }

  return `The selected language impacts the translation of ${productList} alarm text only. English will be used for the rest of the application text.`;
};
